import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  TextField,
  Paper,
} from "@mui/material";
import {
  UploadFile as UploadIcon,
  Edit as EditIcon,
  Handshake,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const FinanceForm = ({
  handleSave,
  handleChange,
  formData,
  errors,
  hasChanges,
  handleFileUpload,
  setFormData,
}) => {
  const { vendorProfileDetails } = useSelector((state) => state.vendorProfile);
  const handleDelete = () => {
    const updatedFormData = {
      ...formData,
      chequeBookImageURL: "",
    };
    setFormData(updatedFormData);
    handleSave(); 
  };

  return (
    <Box p={2}>
      <Card variant="outlined" sx={{ borderRadius: 5 }}>
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography sx={{ fontWeight: "bold" }} variant="h6">
              Financial Details
            </Typography>
            <Box>
              {hasChanges && (
                <Box display="flex" justifyContent="flex-end" mb={2}>
                  <Button
                    onClick={handleSave}
                    startIcon={<SaveIcon />}
                    variant="contained"
                    color="primary"
                  >
                    Save
                  </Button>
                </Box>
              )}
            </Box>
          </Box>

          <Box sx={{ overflowY: "scroll", maxHeight: "48vh" }}>
            <Grid container spacing={3}>
              {/* Bank holder name */}
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      color: errors.bankAccountHolderName
                        ? "#d32f2f"
                        : "inherit",
                    }}
                    gutterBottom
                  >
                    Bank Account Holder Name
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="bankAccountHolderName"
                    value={formData.bankAccountHolderName}
                    onChange={handleChange}
                    error={!!errors.bankAccountHolderName}
                    helperText={errors.bankAccountHolderName}
                  />
                </Box>
              </Grid>
              {/* Bank acoount number */}
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      color: errors.bankAccountNumber ? "#d32f2f" : "inherit",
                    }}
                    gutterBottom
                  >
                    Bank Account Number
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="bankAccountNumber"
                    value={formData.bankAccountNumber}
                    onChange={handleChange}
                    error={!!errors.bankAccountNumber}
                    helperText={errors.bankAccountNumber}
                  />
                </Box>
              </Grid>
              {/* Bank */}

              <Grid item xs={12} md={6}>
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      color: errors.bankName ? "#d32f2f" : "inherit",
                    }}
                    gutterBottom
                  >
                    Bank
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="bankName"
                    value={formData.bankName}
                    onChange={handleChange}
                    error={!!errors.bankName}
                    helperText={errors.bankName}
                  />
                </Box>
              </Grid>
              {/* Bank IFSC code */}

              <Grid item xs={12} md={6}>
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      color: errors.bankIFSCCode ? "#d32f2f" : "inherit",
                    }}
                    gutterBottom
                  >
                    IFSC
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="bankIFSCCode"
                    value={formData.bankIFSCCode}
                    onChange={handleChange}
                    error={!!errors.bankIFSCCode}
                    helperText={errors.bankIFSCCode}
                  />
                </Box>
              </Grid>

              {/* Pan number */}

              <Grid item xs={12} md={6}>
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 600,
                      color: errors.PANNumber ? "#d32f2f" : "inherit",
                    }}
                    gutterBottom
                  >
                    PAN
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="PANNumber"
                    value={formData.PANNumber}
                    onChange={handleChange}
                    error={!!errors.PANNumber}
                    helperText={errors.PANNumber}
                  />
                </Box>
              </Grid>
            </Grid>

            {/* Upload Cheque Book */}
            <Box mt={6}>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600 }}
                gutterBottom
              >
                Cheque Book
              </Typography>

              {/* Hidden input for uploading */}
              <input
                type="file"
                accept="image/png, image/jpeg"
                id="upload-cheque-book"
                style={{ display: "none" }}
                onChange={(e) => handleFileUpload(e, "chequeBookImageURL")}
              />

              <label htmlFor="upload-cheque-book">
                {!formData.chequeBookImageURL ? (
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 4,
                      borderStyle: "dashed",
                      textAlign: "center",
                      cursor: "pointer",
                      transition: "0.3s",
                      "&:hover": {
                        borderColor: "primary.main",
                      },
                    }}
                  >
                    <UploadIcon color="primary" sx={{ fontSize: 40, mb: 2 }} />
                    <Typography color="primary">
                      Click here to upload
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Supported Format: JPG, PNG (2MB max)
                    </Typography>
                  </Paper>
                ) : (
                  <Box mt={2} textAlign="center">
                    <Typography variant="caption" color="text.secondary">
                      Uploaded File:
                    </Typography>
                    <Box
                      mt={1}
                      sx={{
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      {/* <IconButton
                        size="small"
                        sx={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          backgroundColor: "white",
                          "&:hover": {
                            backgroundColor: "grey.100",
                          },
                        }}
                        onClick={handleDelete}
                      >
                        <DeleteIcon fontSize="small" color="error" />
                      </IconButton> */}
                      <img
                        src={formData.chequeBookImageURL}
                        alt="Cheque Book"
                        style={{ maxWidth: "200px", borderRadius: "8px" }}
                      />
                    </Box>
                  </Box>
                )}
              </label>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default FinanceForm;
